import { JSX } from 'react';
import { Box, Text, Divider } from '@chakra-ui/react';
import { getFulfilmentProp, getRefereeRelationshipText } from '@/utilities/fulfilmentData';
import { FulfilmentRendererProps } from './BaseFulfilmentDataRenderer';
import type { IReferee } from 'types';
import { useTranslation } from "react-i18next";

export default function RefereeDetailsFulfilmentRenderer({
  fulfilmentData,
}: FulfilmentRendererProps): JSX.Element | null {
    const { t } = useTranslation('common');
  const referees = getFulfilmentProp(fulfilmentData, 'referees');

  if (!fulfilmentData || !Array.isArray(referees) || referees.length === 0) {
    return null;
  }

  return (
    <Box>
      {(referees as IReferee[]).map((referee, index) => (
        <Box key={`${referee.email}-${index}`}>
          {index > 0 && <Divider my={2} />}
          <Text fontSize="sm" mb={0} color="muted">
            {getRefereeRelationshipText(referee)}: {referee.name},
          </Text>
          <Text fontSize="sm" mb={0} color="muted">
            {referee.occupation} {t('common:at')} {referee.organisation}
          </Text>
          <Text fontSize="sm" color="muted">
            {referee.email}
          </Text>
        </Box>
      ))}
    </Box>
  );
}
